import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from 'modules/Devices/DeviceFullInfo/deviceFullInfoState/deviceFullInfoContext';
import classNames from 'classnames';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		resetDropboxPushFields,
		selectedDropboxPushFileType,
		selectedDropboxPushMessage,
		dropboxPushParams,
	} = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	const containerClasses = classNames(style.container, {
		[style.visible]: selectedDropboxPushFileType || selectedDropboxPushMessage || dropboxPushParams,
	});

	const handleCancel = () => {
		changeTypeOfModalWindow(null);
		resetDropboxPushFields();
	};

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit">
					<Text translationNameSpace="form" translationKey="dropboxPushButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
